import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useEffect } from "react";
import Expert from "./pages/expert/expert";
import Payment from "./pages/Payments/payment";
import Comments from "./pages/comments/comment";

import Dashboard from "./pages/dashboard/dashboard";
import Faq from "./pages/faq/faq";
import Terms from "./pages/terms/terms";
import Privacy from "./pages/privacy/privacy";
import Plan from "./pages/plan/plan";
import Profile from "./pages/profile/profile";
import Notification from "./pages/notification/notification";
import Favorites from "./pages/favorites/favorites";
import Spinner from "./components/Spinner/spinner";
import Error from "./pages/error/error";
import Signin from "./pages/signin/signin";
import Signupmodal from "./pages/signupmodal/signup";
import Signup from "./pages/signup/signup";
import Header from "./components/header/header";
import Footer from "./components/footer";
import Recover_password from "./pages/recover_password/recover_password";
import Bycall from "./pages/expert/Modals/bycall";
import Bychat from "./pages/expert/Modals/bychat";
import Bycredit from "./pages/expert/Modals/bycredit";
import Buycredit from "./pages/expert/Modals/buycredit";
import Consultation from "./pages/consultations/consultation";
import Messages from "./pages/messages/messages";
import Redirect from "./Redirect";
import ProtectedRoute from "./protectRoute";
import "react-tooltip/dist/react-tooltip.css";

const MainLayout = ({ data }) => {
  return (
    <div className="page">
      <Header data={data} />
      <div className="main-content app-content">
        <div className="container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
const AuthLayout = () => {
  return (
    <div className="auth-page">
      <Outlet />
    </div>
  );
};
function App() {
  const ceuille = 4;
  useEffect(() => {
    const existingLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1];

    const defaultLang = process.env.REACT_APP_LANG || "en";

    if (!existingLang) {
      localStorage.setItem("lang", defaultLang);
      document.cookie = `lang=${defaultLang}; expires=Thu, 01 Jan 2099 00:00:00 UTC; path=/`;
    }
  }, []);

  return (
    <BrowserRouter basename="/portal">
      <TitleUpdater />
      <div className="App">
        <Routes>
          <Route element={ <ProtectedRoute><MainLayout /> </ProtectedRoute>}>
            <Route
              path="/experts"
              element={
               
                  <Expert max={ceuille} />
               
              }
            />
            <Route
              path={`/consultations`}
              element={
                  <Consultation />
              }
            />
            <Route
              path={`/payments`}
              element={
                  <Payment />
              }
            />
            <Route
              path={`/comments`}
              element={
                  <Comments />
              }
            />
            <Route
              path={`/messages`}
              element={
                  <Messages />
              }
            />
            <Route
              path="/"
              element={
                  <Dashboard />
              }
            />
            <Route
              path={`/faq`}
              element={
                  <Faq />
              }
            />
            <Route
              path={`/terms`}
              element={
                  <Terms />
              }
            />
            <Route
              path={`/privacy`}
              element={
                  <Privacy />
              }
            />
            <Route
              path={`/plans`}
              element={
                  <Plan />
              }
            />
            <Route
              path={`/profile`}
              element={
                  <Profile />
              }
            />
            <Route
              path={`/notifications`}
              element={
                  <Notification />
              }
            />
            <Route
              path={`/wishlist`}
              element={
                  <Favorites />
              }
            />
            <Route path={`/spinner`} element={<Spinner />} />
          </Route>
          <Route element={<AuthLayout />}>
            <Route path={`/signin`} element={<Signin />} />
            <Route path={`/signup`} element={<Signup />} />
            <Route path={`/recover_password`} element={<Recover_password />} />
          </Route>
          <Route path={`/error`} element={<Error />} />
          <Route path={`/signupmodal`} element={<Signupmodal />} />
          <Route path={`/bycall`} element={<Bycall />} />
          <Route path={`/bychat`} element={<Bychat />} />
          <Route path={`/bycredit`} element={<Bycredit />} />
          <Route path={`/buycredit`} element={<Buycredit />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

function TitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const langCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("lang="));

    const path = location.pathname.split("/").pop();
    const pageName =
      path.charAt(0).toUpperCase() + path.slice(1) || "Dashboard";
    document.title = `${pageName} | DIVINARO PORTAL`;
  }, [location]);

  return null;
}


  
export default App;
